import { getTypedState } from 'ducks/hooks'
import { SubscriptionsType } from './types'

export const getSubscriptions = (type: keyof SubscriptionsType) => (): any => {
  const { subscriptions } = getTypedState()
  return subscriptions[type as keyof SubscriptionsType];
}

export const getSubscriptionsValue = (type: keyof SubscriptionsType) => (): any => {
  const { subscriptions } = getTypedState()
  // if (!orderMaintenance) return null
  return subscriptions[type as keyof SubscriptionsType]
}

export const territoryIsAvailableForMaintenance = (territoryId?: string) => (): boolean => {
  const { subscriptions } = getTypedState()
  if (!territoryId || !subscriptions?.plans || subscriptions.plans.length <= 0) return false
  return subscriptions.plans[0].validTerritoryIds.includes(territoryId)
}
